import React, { Component } from 'react';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import PropTypes from 'prop-types';
import renderIf from 'render-if';
import Button from 'components/CustomButton';
import Error from 'components/ErrorMessage';
import UserInfo from '../../../Userinfo/index';
import styles from './styles.scss';

// to import local scss fle

class StudentEvaluation extends Component {
  static propTypes = {
    userInfo: PropTypes.shape.isRequired,
    setTabToInitial: PropTypes.func.isRequired,
    evaluateStudent: PropTypes.func.isRequired,
    evaluatedInfo: PropTypes.shape.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      evaluationText: '',
      showError: false,
      errorMessage: '',
    };
  }

  componentWillMount() {
    this.setState({ evaluationText: this.props.userInfo.evaluationText });
  }

  handleChange = (event) => {
    this.setState({ evaluationText: event });
  };

  evaluateStudent = () => {
    if (this.state.evaluationText !== '') {
      const payload = {
        student_id: this.props.userInfo.student_id,
        evaluation_text: this.state.evaluationText,
      };
      this.props.evaluateStudent(payload);
    } else {
      this.setState({ showError: true });
    }
  };

  removeErrorMessage = () => {
    this.setState({ showError: false });
  };

  render() {
    const { userInfo, setTabToInitial, evaluatedInfo } = this.props;
    const { showError, evaluationText } = this.state;
    const renderUserNotSelected = renderIf(userInfo.name === undefined);
    const renderUserSelected = renderIf(userInfo.name !== undefined && !evaluatedInfo);
    const renderSuccessMessage = renderIf(evaluatedInfo && userInfo.name !== undefined);
    const renderErrorMessage = renderIf(showError);
    return (
      <div className={cn('col s12', styles.removePadding)}>
        {renderUserNotSelected(<Error message="Please select user in first tab" />)}
        {renderUserSelected(
          <div className={cn('col s12', styles.container)}>
            <UserInfo userInfo={userInfo} userType="STUDENT" /><br />
            <div className={cn('col s12', styles.actionContainer)}>
              <span className={styles.selectPlan}>Add description about student.</span> <br />
            </div>
            <textarea
              value={evaluationText || ''}
              className={styles.textarea}
              onFocus={this.removeErrorMessage}
              onChange={event => this.handleChange(event.target.value)}
            />
            {renderErrorMessage(
              <Error message="Please add something to update." />,
            )}
          </div>)}
        {renderUserSelected(
          <Button label="EVALUATE ABOVE STUDENT" style={styles.buttonContainer} onClick={this.evaluateStudent} />)}
        {renderUserNotSelected(<Button label="SELECT USER" style={styles.buttonContainer} onClick={setTabToInitial} />)}
        {renderSuccessMessage(
          <span>
            <span className={styles.successMessage}>Below description is added to user.</span>
            <br /> <br />
            <spam>{this.state.evaluationText}</spam>
          </span>,
        )}
      </div>
    );
  }
}

export default StudentEvaluation;



// WEBPACK FOOTER //
// ./src/containers/Admin/components/StudentView/components/StudentEvaluation/View.js